export default "__VITE_ASSET__86167395__"